import React, { useState, useEffect } from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Collapse from '@mui/material/Collapse';
import Box from '@mui/material/Box';

export default function NotificationBar({status, setStatus}) {
    const [open, setOpen] = useState(true)

    useEffect(() => {
        const timer = setTimeout(() => {
            setStatus('neutral');
            setOpen(false);
        }, 5000);

        return () => {
            clearTimeout(timer);
        };
    }, []);

    console.log('Notification bar rendered', status)
    
    if(status.notificationType === 'success'){
        console.log('Alert bar ran')
        return(
            <Alert severity="success">
                <AlertTitle>Success</AlertTitle>
                {status.message} — <strong>check it out!</strong>
            </Alert>
        )
    }else if(status.notificationType === 'error'){
        return(
            <Alert severity="error">
                <AlertTitle>Error</AlertTitle>
                {status.message} — <strong>check it out!</strong>
            </Alert>
        )
    }else if (status.notificationType === 'info') {
        return(
            <Alert severity="info">
                <AlertTitle>Info</AlertTitle>
                {status.message} — <strong>check it out!</strong>
            </Alert>
        )
    }else if (status.notificationType === 'info'){
        return(
            <Alert severity="warning">
                <AlertTitle>Warning</AlertTitle>
                {status.message} — <strong>check it out!</strong>
            </Alert>
        )
    }else {
        return(
            null
        )
    }
}